import axios from "axios";

export default axios.create({
  baseURL: "https://bauhaus.vooster.io:443",
  timeout: 0,
  headers: {
    "Content-type": "application/json",
  },
});
